import { css } from '@emotion/react';

export const SummarySeparator = () => {
	return (
		<div
			css={css`
				height: 1px;
				background: #f1f1f4;
				margin: 20px 0;
			`}
		></div>
	);
};
